import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { postRequestGlobal } from "../../../API/global"; // Check path correctness
import { Link } from "react-router-dom";
import IP from "../../../images/peck2.jpg";
import Loader from "../Loader/Loader";

const VerifyEmail = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState();
  const [messageColor, setMessageColor] = useState("green");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await postRequestGlobal(`verify/${token}`, {});

        if (response.status === true) {
          setMessageColor("green");
        } else {
          setMessageColor("red");
        }

        setMessage(response.message);
      } catch (error) {
        console.error("Error verifying email:", error); // Log any frontend errors
        setMessageColor("red");
        setMessage(
          "An error occurred during email verification. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="container-fluid px-0 w-100 overflow-x-hidden position-absolute">
      {loading && <Loader />}
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-6 overflow-x-hidden">
          <img
            src={IP}
            className="mob-IP"
            alt="Indian Panorama"
            width="100%"
            height="100%"
          />
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 second-box">
          <div className="container">
            <div className="row mt-5">
              <div className="col-12 mt-5">
                {!loading && (
                  <>
                    <h2 style={{ color: messageColor }}>{message}</h2>
                    <div className="button">
                      <Link to="/" className="login">
                        Go to Homepage
                      </Link>
                    </div>
                  </>
                )}
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
